import { MoviesByDateResponse, ShowTimesResponse } from './models';
import { createInfiniteQuery, createQuery } from '../../libs';
import { short_term_cashing } from '@/constants/cashing';

const url = 'showtimes';

export const useGetShowtimesByOneCinema = createQuery<ShowTimesResponse, unknown>(
  {
    method: 'get',
    url: `${url}`,
  },
  {
    staleTime: short_term_cashing,
  }
);

export const useGetMoviesByDate = createQuery<MoviesByDateResponse, unknown>(
  {
    method: 'get',
    url: `films/${url}`,
  },
  {
    staleTime: short_term_cashing,
  }
);

export const useGetShowTimesMoviesByDate = createInfiniteQuery<MoviesByDateResponse>(
  {
    method: 'get',
    url: `films/${url}`,
  },
  {
    staleTime: short_term_cashing,
    keepPreviousData: false,
  }
);
